import React from 'react';

import styles from './styles/box-message.module.css';

import Loading from '../../common/Loading';
import {ReactComponent as ReloadIcon} from '../../../assets/design-system/arrow-rotate-right.svg';
import {ReactComponent as ErrorRoundIcon} from '../../../assets/design-system/error-round.svg';
import {ReactComponent as Search02Icon} from '../../../assets/design-system/search-02.svg';

export default function BoxMessage({ width, height, iconSize, reloadIconSize, type, icon, message, subMessage, handleReload }) {
    const size = iconSize || '24px';

    const reloadSize = reloadIconSize || '16px';

    const getIcon = () => {
        if (type === 'no-search') return <Search02Icon />;
        if (type === 'error') return <ErrorRoundIcon />;

        return icon;
    };

    const getMessage = () => {
        if (type === 'loading') return <Loading />;
        if (type === 'no-search') return '검색된 결과 없음';
        if (type === 'error') return <>페이지를 불러오는 중 <span>오류</span> 발생</>;

        return message;
    };

    const getSubMessage = () => {
        if (type === 'no-search') return '다른 검색어를 입력해 보세요';
        if (type === 'error') return '재시도';

        return subMessage;
    };
    
    return (
        <div className={styles.wrapper} style={{ width, height }}>
            <div style={{ width: size, height: size, color: 'var(--main_purple)' }}>
                {getIcon()}
            </div>
            <div className={styles.message}>{getMessage()}</div>
            <div
                className={styles.subMessage}
                data-type={type}
                onClick={type === 'error' ? handleReload : null}
            >
                {getSubMessage()}
                {type === 'error' &&
                    <div style={{ width: reloadSize, height: reloadSize, color: 'var(--gray-dark)' }}>
                        <ReloadIcon />
                    </div>
                }
            </div>
        </div>
    );
}
